/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { OnboardingDraftService, UpdateOnboardingServiceApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingService: build.mutation<OnboardingDraftService, UpdateOnboardingServiceApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/onboarding/services/${queryArg.serviceId}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingServiceApi };
export const { useUpdateOnboardingServiceMutation } = injectedRtkApi;
